import * as React from 'react';
import { useSelector } from 'react-redux';

import { LinksBlock } from '../../components/LinksBlock';
import { IApplicationState } from '../../types/redux';
import { selectEventCategory } from '../../selectors/eventCategory';
import { trackLinkClick } from './tracking';

export const LinksBlockContainer: React.FC = () => {
  const isAdditionalLinksVisible = useSelector((state: IApplicationState) => state.showAdditionalSeoLinks);
  const eventCategory = useSelector(selectEventCategory);

  const handleLinkClick = (event: React.MouseEvent<HTMLAnchorElement>, name: string) => {
    trackLinkClick({ category: eventCategory, label: name });
  };

  return <LinksBlock withAdditionalLinks={isAdditionalLinksVisible} onLinkClick={handleLinkClick} />;
};
